import { CurrencyOption } from '../interfaces/currencyoption.interface';

export const CURRENCY_OPTIONS: CurrencyOption[] = [
  { code: 'SEK', name: 'Svensk krona' },
  { code: 'AUD', name: 'Australisk dollar' },
  { code: 'BGN', name: 'Bulgarisk lev' },
  { code: 'BRL', name: 'Brasiliansk real' },
  { code: 'CAD', name: 'Kanadensisk dollar' },
  { code: 'CHF', name: 'Schweizisk franc' },
  { code: 'CNY', name: 'Kinesisk yuan' },
  { code: 'CZK', name: 'Tjeckisk koruna' },
  { code: 'DKK', name: 'Dansk krone' },
  { code: 'EUR', name: 'Euro' },
  { code: 'GBP', name: 'Brittiskt pund' },
  { code: 'HKD', name: 'Hongkong-dollar' },
  { code: 'HUF', name: 'Ungersk forint' },
  { code: 'IDR', name: 'Indonesisk rupiah' },
  { code: 'ILS', name: 'Israelisk shekel' },
  { code: 'INR', name: 'Indisk rupie' },
  { code: 'ISK', name: 'Isländsk krona' },
  { code: 'JPY', name: 'Japansk yen' },
  { code: 'KRW', name: 'Sydkoreansk won' },
  { code: 'MXN', name: 'Mexikansk peso' },
  { code: 'MYR', name: 'Malaysisk ringgit' },
  { code: 'NOK', name: 'Norsk krone' },
  { code: 'NZD', name: 'Nyzeeländsk dollar' },
  { code: 'PHP', name: 'Filippinsk peso' },
  { code: 'PLN', name: 'Polsk zloty' },
  { code: 'RON', name: 'Rumänsk leu' },
  { code: 'SGD', name: 'Singaporiansk dollar' },
  { code: 'THB', name: 'Thailändsk baht' },
  { code: 'TRY', name: 'Turkisk lira' },
  { code: 'USD', name: 'Amerikansk dollar' },
  { code: 'ZAR', name: 'Sydafrikansk rand' },
];
